interface ProgressoWizardProps {
  atual: number;
  total: number;
  respondidas: number;
}

export function ProgressoWizard({ atual, total, respondidas }: ProgressoWizardProps) {
  const percentual = Math.round((respondidas / total) * 100);

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-sm">
        <span className="font-medium text-gray-700">
          Pergunta {atual} de {total}
        </span>
        <span className="text-gray-500">{respondidas} respondida(s)</span>
      </div>

      <div
        className="h-2 w-full overflow-hidden rounded-full bg-gray-200"
        role="progressbar"
        aria-valuenow={percentual}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className="h-full rounded-full bg-primary-600 transition-all duration-300"
          style={{ width: `${percentual}%` }}
        />
      </div>
    </div>
  );
}
